import {
  fifteen,
  twenty,
  thirty,
  forty,
  eighty,
  social,
  navigation,
  others
} from './constants';

export const iconsSet = [
  ...fifteen,
  ...twenty,
  ...thirty,
  ...forty,
  ...eighty,
  ...social,
  ...navigation,
  ...others
];



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/iconset.js